import type { ReactNode } from 'react';

import { BrandMark } from './brand.js';

export function AuthLayout({ children }: { readonly children: ReactNode }): ReactNode {
  return (
    <div className="grid min-h-dvh lg:grid-cols-[1.15fr_0.95fr]">
      <section
        className="relative hidden flex-col justify-between px-16 pt-12 pb-16 lg:flex"
        style={{
          background:
            'radial-gradient(ellipse 80% 60% at 12% 18%, rgb(47 104 226 / 0.22), transparent 55%),' +
            'linear-gradient(145deg, #01102D 0%, #06183D 55%, #0A214F 100%)',
        }}
      >
        <BrandMark tone="white" />
        <div className="max-w-[520px]">
          <span className="eyebrow text-cyan">Task Management</span>
          <h1 className="mt-3 text-[clamp(36px,4.5vw,48px)] leading-[1.05] font-bold tracking-[-0.03em] text-white">
            Ready. Responsive. Reliable.
          </h1>
          <p className="mt-4 max-w-[38ch] text-[17px] leading-[1.55] text-white/70">
            One command center for departments, projects, procurement, and recruitment across Silver
            Bell Group.
          </p>
        </div>
      </section>

      <section className="flex items-center justify-center bg-white p-6 lg:p-8">
        <div className="w-full max-w-[420px]">{children}</div>
      </section>
    </div>
  );
}
